import React from "react"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../DataTable/DataTable"

class PortalAllFolioTransactions extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div>
        <DataTable
            hideHeaderActions={true}
            endpoint={this.props.portal_all_folio_transactions_datatable_path}
            no_data_text={I18n.t('none')}
            currency_unit={I18n.t('number.currency.format.unit')}
            delimiter={I18n.t('number.currency.format.delimiter')}
            separator={I18n.t('number.currency.format.separator')}
            date_format={this.props.date_format}
            time_format={this.props.time_format} />
      </div>
    )
  }
}

export default PortalAllFolioTransactions
